import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { RepeatOrderService } from '@app/shared/services/repeat-order.service';
import { OrderDataService } from '@app/shared/services/order-data.service';

import { forkJoin, of } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { TempRemaService } from '@app/shared/services/temp-rema.service';
@Component({
  selector: 'app-rema-test',
  templateUrl: './rema-test.component.html',
  styleUrls: ['./rema-test.component.css']
})
export class RemaTestComponent implements OnInit{

  tempRemaForm: FormGroup;
  tickets = []; // Array to hold all ticket numbers
  rowCount: number = 1; // Default row count set to 1

  constructor(
    private formBuilder: FormBuilder,private Router:Router,
    private repeatOrderService: RepeatOrderService,
    private orderDataService: OrderDataService,private tempRemaService:TempRemaService, private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    // Fetch both repeat orders and unsaved orders
    // forkJoin({
    //   repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
    //   unsavedOrders: this.orderDataService.getAllUnsavedOrders()
    // }).subscribe(response => {
    //   // Ensure the response objects are arrays, otherwise set them as empty arrays
    //   const repeatOrders = Array.isArray(response.repeatOrders) ? response.repeatOrders : [];
    //   const unsavedOrders = Array.isArray(response.unsavedOrders) ? response.unsavedOrders : [];

    //   // Combine both orders into a single array (could also add custom properties to differentiate)
    //   this.tickets = [...repeatOrders, ...unsavedOrders];
    //    // Sort tickets in ascending order based on ticketNo
    // this.tickets.sort((a, b) => {
    //   const ticketNoA = a.ticketNo ? a.ticketNo : '';
    //   const ticketNoB = b.ticketNo ? b.ticketNo : '';
    //   return ticketNoA.localeCompare(ticketNoB); // Ensure correct sorting by ticketNo
    // });

    //   this.cdr.detectChanges(); // This forces the UI to update after data is populated

    //   console.log("ticket",this.tickets);
    // });
    forkJoin({
     
      unsavedOrders: this.orderDataService.getAllUnsavedOrders(),
        repeatOrders: this.repeatOrderService.getAllRepeatOrder(),
    }).subscribe(response => {
      // Ensure the response objects are arrays, otherwise set them as empty arrays
    
      const unsavedOrders = Array.isArray(response.unsavedOrders) ? response.unsavedOrders : [];
        const repeatOrders = Array.isArray(response.repeatOrders) ? response.repeatOrders : [];

      // Combine both orders into a single array (could also add custom properties to differentiate)
     
       this.tickets = [...unsavedOrders, ...repeatOrders];
       // Sort tickets in ascending order based on ticketNo
    // this.tickets.sort((a, b) => {
    //   const ticketNoA = a.ticketNo ? a.ticketNo : '';
    //   const ticketNoB = b.ticketNo ? b.ticketNo : '';
    //   return ticketNoA.localeCompare(ticketNoB); // Ensure correct sorting by ticketNo
    // });
    this.tickets.sort((a, b) => {
  const ticketNoA = a.ticketNo ? a.ticketNo : '';
  const ticketNoB = b.ticketNo ? b.ticketNo : '';
  return ticketNoA.localeCompare(ticketNoB);
}).reverse();


      this.cdr.detectChanges(); // This forces the UI to update after data is populated

      console.log("ticket",this.tickets);
    });
    
      // Initialize the form with a default single row
      this.tempRemaForm = this.formBuilder.group({
        ticketNo: ['', Validators.required],
        jobName: ['', Validators.required],
        // width: ['', Validators.required],
        date: ['', Validators.required],


        refNo: ['', Validators.required],        // Add refNo
        poNumber: ['', Validators.required],      // Add poNumber
        std: ['', Validators.required],           // Add std
        clientName: ['', Validators.required],      // Add customer
        combinedMaterials: this.formBuilder.array([]), // Add combinedMaterials array (FormArray)



        mat: ['', Validators.required],
       

       
        remarks: ['', Validators.required],

        shift: ['', Validators.required],
        machine: ['', Validators.required],
        operator: ['', Validators.required],

      
      

        rolls: ['', Validators.required],
         rollcount: ['', Validators.required],
        jco: ['', Validators.required], 
        input: ['', Validators.required],
        output: ['', Validators.required],

        extra: ['', Validators.required],

          // glueSupplier: ['', Validators.required],
        tpcs: ['', Validators.required],
        pckg: ['', Validators.required],

         sac: ['', Validators.required],
        bndl: ['', Validators.required],
        bundles: ['', Validators.required],
       
      });
        // Initially apply enteredRollNo to the first row if provided
    const enteredRollNo = this.tempRemaForm.get('enteredRollNo')?.value;
    if (enteredRollNo) {
      const rowArray = this.tempRemaForm.get('row') as FormArray;
      const firstRow = rowArray.at(0); // Get the first row
      firstRow.patchValue({
        rollNo: enteredRollNo  // Set the rollNo of the first row to enteredRollNo
      });
    }





    // this.tempRemaForm.valueChanges.subscribe(() => {
    //   this.calculateFormValues();
    // });
    
  }
  // Method to create a new row (FormGroup)
 

onTicketSelect(event: any): void {
  const selectedTicketNo = event.target.value;
  if (selectedTicketNo) {
    const selectedTicket = this.tickets.find(ticket => ticket.ticketno === selectedTicketNo);
    if (selectedTicket) {
      // const width = selectedTicket.coilWidth || 'Default Width';
      const jobName = selectedTicket.jobName || 'Default Job Name';

      // const material = selectedTicket.combinedMaterials && selectedTicket.combinedMaterials.length > 0 
      // ? selectedTicket.combinedMaterials[0].material // Extracting the material from the first item
      // : 'Default Material'; // Default if no materials found

       
      // Filter combinedMaterials to get process === "PRINTING"
      const printingMaterial = selectedTicket.combinedMaterials
        ? selectedTicket.combinedMaterials.filter(material => material.process === "PRINTING")
        : [];

      // If there are any materials with process "PRINTING", pick the first one, else use default
      const material = printingMaterial.length > 0 
        ? printingMaterial[0].material 
        : ''; // Default if no material is found with process "PRINTING"
        const thickness = printingMaterial.length > 0 
        ? printingMaterial[0].thickness 
        : ''; // Default thickness if no printing material is found
      const width = printingMaterial.length > 0 
        ? printingMaterial[0].width 
        : ''; // Default width if no printing material is found





        // lamination
        // Filter combinedMaterials to get process === "LAMINATION"
const laminationMaterial = selectedTicket.combinedMaterials
? selectedTicket.combinedMaterials.filter(material => material.process === "LAMINATION")
: [];

// If there are any materials with process "LAMINATION", pick the first one, else use default
const materialLam = laminationMaterial.length > 0 
? laminationMaterial[0].material 
: ''; // Default if no material is found with process "LAMINATION"


        
      this.tempRemaForm.patchValue({
      //  ticketNo: selectedTicket.ticketno,
       jobName: jobName,
      
       // date: selectedTicket.date,
        batch: selectedTicketNo,

        refNo: selectedTicket.refNo || 'Default Ref No',
        poNumber: selectedTicket.poNo || 'Default PO Number',
        clientName: selectedTicket.clientName || 'Default Client Name',
        std: selectedTicket.std || 'Default STD',


        material: material, // Setting the material here
        thickness: thickness, // Setting the thickness here
        width: width, // Setting the material width here

        materialLam: materialLam, // Setting the material here
     
      });

        // Optionally populate the combinedMaterials array if available in the ticket
        if (selectedTicket.combinedMaterials) {
          this.setCombinedMaterials(selectedTicket.combinedMaterials);
        }
     
    }
  }
}



setCombinedMaterials(materials: any[]) {
  const combinedMaterialsFormArray = this.tempRemaForm.get('combinedMaterials') as FormArray;

  // Clear any existing materials in the array before adding new ones
  combinedMaterialsFormArray.clear();

  materials.forEach(material => {
    combinedMaterialsFormArray.push(this.formBuilder.group({
      material: [material.material || ''],          
      density: [material.density || ''],            
      gsm: [material.gsm || ''],                    
      matRequired: [material.matRequired || ''],    
      netRm: [material.netRm || ''],                
      process: [material.process || ''],            
      thickness: [material.thickness || ''],        
      waste: [material.waste || ''],                
      width: [material.width || ''],                
      _id: [material._id || '']                     
    }));
  });
}


// Add a new material row
addMaterial(): void {
  const combinedMaterialsFormArray = this.tempRemaForm.get('combinedMaterials') as FormArray;
  combinedMaterialsFormArray.push(this.formBuilder.group({
    material: [''],
    density: [''],
    gsm: [''],
    matRequired: [''],
    netRm: [''],
    process: [''],
    thickness: [''],
    waste: [''],
    width: [''],
    _id: ['']
  }));
}

// Remove a material row at a specific index
removeMaterial(index: number): void {
  const combinedMaterialsFormArray = this.tempRemaForm.get('combinedMaterials') as FormArray;
  combinedMaterialsFormArray.removeAt(index);
}

getCombinedMaterialsControls() {
  return (this.tempRemaForm.get('combinedMaterials') as FormArray).controls;
}




// Method to calculate values dynamically
// calculateFormValues(): void {
//   const formData = this.tempRemaForm.value;

//   // Temporarily disable change detection to avoid unnecessary rerenders
//   this.cdr.detach();

//   // Calculate Wastage (ip + job + shade + others)
//   // const wastageFields = ['ip', 'job', 'shade', 'others'];
//   // let wastage = 0;
//   // wastageFields.forEach((field) => {
//   //   const value = parseFloat(formData[field]);
//   //   if (!isNaN(value)) {
//   //     wastage += value;
//   //   }
//   // });

//   // // Set the calculated wastage value to the form field if it has changed
//   // if (this.tempRemaForm.get('wastage').value !== wastage) {
//   //   this.tempRemaForm.patchValue({ wastage });
//   // }

  

//   // Calculate Extra (std - usedSize)
//   const input = parseFloat(formData.input);
//   const output = parseFloat(formData.output);
//   let extra = 0;

//   if (!isNaN(input) && !isNaN(output)) {
//     extra = input - output; // Perform the calculation
//   }

//   // Set the calculated extra value to the form field if it has changed
//   if (this.tempRemaForm.get('extra').value !== extra) {
//     this.tempRemaForm.patchValue({ extra });
//   }


//     // Calculate Waste (wastage - extra)
//     // const waste = wastage - extra;

//     // Set the calculated waste value to the form field if it has changed
//     // if (this.tempRemaForm.get('waste').value !== waste) {
//     //   this.tempRemaForm.patchValue({ waste });
//     // }
  

  

//   // Re-enable change detection after calculations
//   this.cdr.reattach();
// }





 isSubmitting: boolean = false;
tempRema() {
  console.log(this.tempRemaForm.value);
  const formData = this.tempRemaForm.value;

  // Prepare data object to save with all rows
  const dataToSave = {
    ticketNo: formData.ticketNo,
    jobName: formData.jobName,
    // width: formData.width,
    date: formData.date,



    refNo: formData.refNo,       // Add refNo
    poNumber: formData.poNumber,   // Add poNumber
    std: formData.std,     // Add std
    clientName: formData.clientName,

    mat: formData.mat,
   

 
    remarks: formData.remarks,



    shift: formData.shift,
        machine: formData.machine,
        operator: formData.operator,
     
        input: formData.input,
        output: formData. output,
       rollcount: formData.rollcount,
        rolls: formData.rolls,
        wastage: formData. wastage,
    
        jco: formData.jco,

        extra: formData.extra,

            // glueSupplier: formData.glueSupplier,
        tpcs: formData.tpcs,
        pckg: formData.pckg,

         sac: formData.sac,
        bndl: formData. bndl,
        bundles: formData.bundles,
   
   
   
  };

   this.isSubmitting = true;  // Disable the button when submitting

  // Call the service to save data
  this.tempRemaService.addTempRema(dataToSave).subscribe(
    (response) => {
      console.log('Data saved successfully:', response);
      // Optionally reset form or perform other actions after successful save tempRemaList
       this.isSubmitting = false;  // Re-enable the button after successful save
      this.Router.navigateByUrl('/remaProdTable');  // This will redirect to the Table

    },
    (error) => {
      console.error('Error saving data:', error);
       this.isSubmitting = false;  // Re-enable the button after successful save
    }
  );
}

}
